import { Settings } from "lucide-react";

import { LanguageSwitcher } from "@/components/LanguageSwitcher";
import { ThemeSwitcher } from "@/components/ThemeSwitcher";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { useLanguage } from "@/contexts/LanguageContext";
import { cn } from "@/lib/utils";

interface PreferenceSettingsMenuProps {
  className?: string;
}

export function PreferenceSettingsMenu({ className }: PreferenceSettingsMenuProps) {
  const { t } = useLanguage();

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="ghost"
          size="icon"
          className={cn(
            "h-11 w-11 rounded-full border border-clinic-primary/25 bg-clinic-primary/10 text-clinic-primary shadow-lg backdrop-blur-md transition hover:border-clinic-primary/35 hover:bg-clinic-primary/15 hover:text-clinic-primary-hover focus-visible:ring-clinic-primary",
            className,
          )}
          aria-label={t("Abrir preferências")}
          title={t("Preferências")}
          data-testid="preferences-settings-trigger"
        >
          <Settings size={18} />
        </Button>
      </PopoverTrigger>
      <PopoverContent
        align="end"
        sideOffset={10}
        className="w-[min(calc(100vw-2rem),22rem)] rounded-2xl border-clinic-border bg-clinic-surface p-4 text-clinic-text shadow-xl"
      >
        <div className="mb-4 space-y-1">
          <h2 className="text-sm font-heading font-semibold text-clinic-text">
            {t("Preferências")}
          </h2>
          <p className="text-xs text-clinic-text-muted">
            {t("Ajuste idioma e tema da interface.")}
          </p>
        </div>

        <div className="space-y-4">
          <LanguageSwitcher variant="panel" />
          <ThemeSwitcher />
        </div>
      </PopoverContent>
    </Popover>
  );
}
